import * as clipboard from "clipboard-polyfill"

interface ClipboardDataWindow extends Window {
    clipboardData: DataTransfer | null;
  }

class ClipboardHelper {  

    public async copyToClipboard(text: string) {
        clipboard.writeText(text);
    }
}


export const clipboardHelper = new ClipboardHelper();